export default {"src":"/_next/static/media/ca.a628373a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};